import { QueryClient } from '@tanstack/react-query';

// React Query's default networkMode ('online') pauses a mutation while the browser
// is offline: no request, no onError, the button spins until the connection is back.
// 'always' sends it, so the network error reaches the "Server unreachable" toast.
export const queryClient = new QueryClient({
  defaultOptions: { mutations: { networkMode: 'always' } },
});
